// src/components/IndemnizacionForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap';
import BotonMenu from './BotonMenu';
import Banners from './Banners';

const IndemnizacionForm = () => {
    const [salarioMensual, setSalarioMensual] = useState('');
    const [aniosTrabajados, setAniosTrabajados] = useState('');
    const [resultado, setResultado] = useState(null);
    const [error, setError] = useState('');
    const navigate = useNavigate(); 

    const calcularIndemnizacion = () => {
        setError('');
        setResultado(null);


        const salario = parseFloat(salarioMensual);
        const anios = parseInt(aniosTrabajados, 10);

        if (isNaN(salario) || salario <= 0) {
            setError('Por favor, ingresa un salario mensual válido y positivo.');
            return;
        }
        if (isNaN(anios) || anios < 0) {
            setError('Por favor, ingresa un número de años trabajados válido y no negativo.');
            return;
        }

        // Simplificación: Suponemos 1 mes de salario por año trabajado
        // En la vida real, las leyes de indemnización son mucho más complejas
        // y varían por país (ej. fracción de año, límites, preavisos, etc.)
        const indemnizacionCalculada = salario * anios;
        setResultado(indemnizacionCalculada.toFixed(2)); // Formatear a 2 decimales
    };

    const resetForm = () => {
        setSalarioMensual('');
        setAniosTrabajados('');
        setResultado(null);
        setError('');
    };

    return (
        <Container className="my-5">
              <Row></Row>              
            <Row className="justify-content-md-center">
                <Banners BannerShow={1} Act={1} ></Banners>
                <Col md={8} lg={8}>
                <BotonMenu></BotonMenu>
                    <Card style={{ marginBottom: '20px' }}>
                        <Card.Body>
                            <Card.Title className="text-center mb-4">Calculadora de Indemnización por Despido</Card.Title>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <Form>
                                <Form.Group className="mb-3" controlId="formSalario">
                                    <Form.Label>Salario Mensual Bruto ($)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Ej: 500.00"
                                        value={salarioMensual}
                                        onChange={(e) => setSalarioMensual(e.target.value)}
                                        step="0.01"
                                        min="0"
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formAnios">
                                    <Form.Label>Años Trabajados</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Ej: 5"
                                        value={aniosTrabajados}
                                        onChange={(e) => setAniosTrabajados(e.target.value)}
                                        min="0"
                                        step="1"
                                    />
                                </Form.Group>

                                <div className="d-grid gap-2">
                                    <Button variant="primary" size="lg" onClick={calcularIndemnizacion}>
                                        Calcular Indemnización
                                    </Button>
                                    <Button variant="secondary" size="lg" onClick={resetForm}>
                                        Limpiar
                                    </Button>
{/*                                     <Button variant="link" onClick={() => navigate('/calculadoras-financieras')} className="ms-2">
                                        Ir a Calculadoras
                                    </Button>    */}                               
                                </div>
                            </Form>

                            {resultado !== null && (
                                <Alert variant="success" className="mt-4 text-center">
                                    <h4 className="alert-heading">Indemnización Estimada:</h4>
                                    <p className="lead">
                                        <strong>${resultado}</strong>
                                    </p>
                                    <hr />
                                    <p className="mb-0">
                                        Este cálculo es una estimación simplificada. Consulta la legislación laboral de tu país o a un experto para un cálculo exacto.
                                    </p>
                                </Alert>
                            )}
                        </Card.Body>
                    </Card>
                    <Row>
                        <Banners BannerShow={2} Act={1} ></Banners>
                    </Row>                       
                </Col>
                <Banners BannerShow={1} Act={1} ></Banners>
              
            </Row>

        </Container>
    );
};

export default IndemnizacionForm;